module.exports = __webpack_public_path__ + "static/img/pic2.682fe88.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/pic2.jpeg
// module id = CbXj
// module chunks = 0